import { render } from "./FooterContent.vue?vue&type=template&id=07da808a&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=07da808a&scoped=true&lang=scss"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07da808a"]])

export default __exports__